(function () {
  if (customElements.get('nn-cart-drawer')) return;

  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  class NnCartDrawer extends HTMLElement {
    constructor() {
      super();
      this._onKeydown = this._onKeydown.bind(this);
    }

    connectedCallback() {
      this.setAttribute('aria-hidden', 'true');
      this.addEventListener('click', this._onClick.bind(this));

      document.addEventListener('nn:cart:added', () => {
        this.refresh().then(() => this.open());
      });
      document.addEventListener('nn:cart:updated', (e) => {
        if (e.detail && e.detail.cart) this._patchSubtotal(e.detail.cart);
      });

      document.querySelectorAll('[data-nn-cart-link]').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey) return;
          event.preventDefault();
          this.refresh().then(() => this.open());
        });
      });
    }

    _onClick(event) {
      const closer = event.target.closest('[data-nn-cart-close]');
      if (closer) { event.preventDefault(); this.close(); return; }

      const stepBtn = event.target.closest('[data-nn-line-step]');
      if (stepBtn) {
        event.preventDefault();
        const line = Number(stepBtn.getAttribute('data-nn-line'));
        const step = Number(stepBtn.getAttribute('data-nn-line-step'));
        const li = this.querySelector('[data-nn-cart-line="' + line + '"]');
        const qtyEl = li && li.querySelector('[data-nn-line-qty]');
        const current = qtyEl ? Number(qtyEl.textContent) : 1;
        this._changeLine(line, Math.max(0, current + step));
        return;
      }

      const removeBtn = event.target.closest('[data-nn-line-remove]');
      if (removeBtn) {
        event.preventDefault();
        const line = Number(removeBtn.getAttribute('data-nn-line'));
        this._changeLine(line, 0);
      }
    }

    async _changeLine(line, qty) {
      this.classList.add('is-loading');
      try {
        await window.NettyNature.cart.changeLine(line, qty);
        await this.refresh();
      } catch (err) {
        console.error('[nn-cart-drawer] change failed', err);
      } finally {
        this.classList.remove('is-loading');
      }
    }

    async refresh() {
      try {
        const res = await fetch('?sections=cart-drawer', { credentials: 'same-origin' });
        if (!res.ok) throw new Error(res.statusText);
        const data = await res.json();
        const html = data['cart-drawer'];
        if (!html) return;
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        const fresh = wrapper.querySelector('[data-nn-cart-body]');
        const current = this.querySelector('[data-nn-cart-body]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      } catch (err) {
        console.warn('[nn-cart-drawer] refresh failed', err);
      }
    }

    _patchSubtotal(cart) {
      const el = this.querySelector('[data-nn-cart-subtotal]');
      if (el && cart && typeof cart.total_price === 'number') {
        el.textContent = formatMoney(cart.total_price, cart.currency);
      }
    }

    open() {
      this.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKeydown);
      const first = this.querySelector(FOCUSABLE);
      if (first) requestAnimationFrame(() => first.focus());
    }

    close() {
      this.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._onKeydown);
    }

    _onKeydown(event) {
      if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(this.querySelectorAll(FOCUSABLE));
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;
      if (event.shiftKey && active === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && active === last) { event.preventDefault(); first.focus(); }
    }
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(Number(cents) / 100);
    } catch (_) {
      return '$' + (Number(cents) / 100).toFixed(2);
    }
  }

  customElements.define('nn-cart-drawer', NnCartDrawer);
})();
